var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal-stethoscope",
      attrs: { size: "lg" },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { variant: "primary" },
                      on: { click: _vm.switchStethoscope }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("continue")) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    {
                      staticClass: "float-right",
                      attrs: { red: "" },
                      on: { click: _vm.close }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("cancel")) + "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-5 col-md-5 col-sm-5 col-xs-12" }, [
          !_vm.$store.state.video.useStethoscope
            ? _c("img", {
                staticClass: "center-block subheader-img",
                attrs: {
                  src: require("img/icons/morillas-svg-icons/primary/stethoscope-unplugged.svg")
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$store.state.video.useStethoscope
            ? _c("img", {
                staticClass: "center-block subheader-img",
                attrs: {
                  src: require("img/icons/morillas-svg-icons/primary/stethoscope-plugged.svg")
                }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-7 col-md-7 col-sm-7 col-xs-12" }, [
          _vm.$store.state.video.useStethoscope
            ? _c("div", [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("stethoscope1")) + "\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("stethoscope3")) + "\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("stethoscope4")) + "\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("stethoscope-refresh")) +
                    "\n        "
                ),
                _c("br"),
                _vm._v(" "),
                !_vm.$uiHelpers.isMobile
                  ? _c("img", {
                      staticClass: "mt-4 rounded-btn",
                      staticStyle: {
                        display: "block",
                        margin: "auto",
                        "background-color": "rgb(78, 140, 255)"
                      },
                      attrs: {
                        src:
                          "/static-appopensalud/img/icons/refresh-icon-blue-fill.svg",
                        title: _vm.$t("refresh-label")
                      }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.$store.state.video.useStethoscope
            ? _c("div", [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("stethoscope5")) + "\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("stethoscope6")) + "\n        "
                ),
                _c("br"),
                _c("br"),
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("stethoscope7")) + "\n      "
                )
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69e45b4d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69e45b4d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video-launcher/StethoscopeModal.vue
// module id = 3049
// module chunks = 31 72